
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1370_161)"}},[_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","transform":"matrix(-1 0 0 1 44 4)","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31 19.288l-.5-.542-.87-.95-1.308-1.429L27 17.722 30.918 22 37 15.358 35.76 14 31 19.288zm-9.965 12.06V18.913H13.67a.66.66 0 00-.474.202.704.704 0 00-.196.489v3.8c.444 0 .87.181 1.184.505.314.324.49.763.49 1.221 0 .458-.176.898-.49 1.222-.314.324-.74.505-1.184.505v3.8c0 .183.07.36.196.488a.66.66 0 00.474.203h7.365zm4.687-12.435h-3.348v12.435h3.348a.66.66 0 00.473-.203.701.701 0 00.196-.488v-3.8c-.444 0-.87-.181-1.183-.505a1.755 1.755 0 01-.49-1.222c0-.458.176-.897.49-1.22.314-.325.74-.507 1.183-.507v-3.799a.704.704 0 00-.196-.489.66.66 0 00-.473-.202z","fill":"#8200FF"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1370_161","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1370_161"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1370_161","result":"shape"}})])])])
          )
        }
      }
    